module.exports = __webpack_public_path__ + "static/media/flower_print.70a4c007.jpg";